import React, { useState, useEffect, useContext } from "react";
import M from "materialize-css";
import { Link, withRouter } from "react-router-dom";
import "./admin.css";
import Avatar from "../../img/avatar-icon.png";
import { StateContext } from "../../App";
import Axios from "axios";

function SideNav(props) {

  const { state, dispatch } = useContext(StateContext);
  const [users, setUsers] = useState([]);
  const Notification = users && users.length;
  
  useEffect(() => {
    var elems = document.querySelector(".sidenav");
    var instances = M.Sidenav.init(elems, null);
  }, []);

  useEffect(() => {
    const getWithdrawalRequest = () => {

      // dispatch({
      //   type: "SET_LOADING", payload: true
      // });
    
      Axios
        .get("/admin/request")
        .then((result) => {
          // console.log(result.data);
          setUsers(result.data);
          
          // dispatch({ type: "SET_LOADING", payload: false });
        })
        .catch((error) => {
          console.log("ERR! Fetching Customer Request ==>", error);
          // dispatch({ type: "SET_LOADING", payload: false });
        });
  
    }

    getWithdrawalRequest();
  }, [])

  const Logout = () => {
    Axios.get("/logout").then((result) => {
      result.data && window.location.assign('/access/#/login');
    });
  };

  return (
    <div id="sidenav">
      <ul id="slide-out" className="sidenav sidenav-fixed indigo darken-3 ">
        <li>
          <div className="user-view">
            <div className="background">{/* <img src="" /> */}</div>

            <img className="circle" src={Avatar} />
            <span className="white-text name">{ state.user && state.user.name }</span>
          </div>
        </li>
        <li>
          <div className="divider"></div>
        </li>
        <li>
          <Link to="/admin-dashboard/customers">all customers </Link>
        </li>
        <li>
          <div className="divider"></div>
        </li>
        <li>
          <Link to="/admin-dashboard/withdrawal">
            withdrawal request 
           {users.length !== 0 && (
              <span className="red notification-icon circle white-text">
                {Notification}
              </span>
            )}
          </Link>
        </li>
        <li>
          <div className="divider"></div>
        </li>
        <li>
          <Link to="/admin-dashboard/deposit">deposit</Link>
        </li>
        <li>
          <div className="divider"></div>
        </li>
        <li>
          <Link to="/admin-dashboard/send_notification">Write a notification</Link>
        </li>
        <li>
          <div className="divider"></div>
        </li>
        <li>
          <a href="#" onClick={Logout}>log out </a>
        </li>
        <li>
          <div className="divider"></div>
        </li>
      </ul>
    </div>
  );
}

export default withRouter(SideNav);
